import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import styles from './TitleField.module.scss';
import useErrorScrollContext from '../../hooks/useErrorScrollContext';

export type TitleFieldProps = TextFieldProps;

export const TitleField: React.FC<TitleFieldProps> = ( {
	variant,
	className,
	...props
} ) => {
	const ref = useErrorScrollContext( !!props.error );
	return (
		<TextField
			variant='standard'
			className={ [ styles.title, className ].join( ' ' ) }
			{ ...props }
			slotProps={ {
				...props.slotProps,
				input: {
					...props.slotProps?.input,
					inputProps: {
						...( props.slotProps?.input && 'inputProps' in props.slotProps.input
							? props.slotProps?.input?.inputProps
							: {} ),
						'data-cy': 'title',
					},
				},
			} }
			ref={ ref }
		/>
	);
};
